// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.director-main-board path[val=\"0\"] {\n  fill: none !important;\n  stroke: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
